import { AxiosRequestConfig } from "axios";
import { apiConfig } from "../config/apiConfig";
import { Api } from "./Api";
import { PaymentIntentRequest } from "../model/final_balance/payment_intent_request";
import { PayLaterRequest } from "../model/final_balance/pay_later";

class PaymentApi extends Api {

  constructor(apiConfig: AxiosRequestConfig) {
    super(apiConfig);
  }

  public getPaymentIntent = (params: PaymentIntentRequest) => this.post("/payment_intent", params);

  public payLater = async (payload: PayLaterRequest) => this.post("/pay_later", payload);

  // TODO this should probably be in the taxAPI...
  public finalBalance = async () => this.get("/final_balance");

  public yourCredits = async () => this.get("/credits");
}

export const paymentApi = new PaymentApi(apiConfig);
